import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { CompanyGroupForPermissionListItems } from "../companyGroup/companyGroupForPermissionListItems";
import { CompanyGroupListItems } from "../companyGroup/companyGroupListItems";
import { CompanyGroupPage } from "../companyGroup/companyGroupPage";
import { UnitNodePermissions } from "../unit/unitNodePermissions";
import { getApiCall, postApiCall } from "./tokenService";
import { CompanyGroupEdit } from "../companyGroup/companyGroupEdit";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";

// #region CompanyGroupPage
export const getCompanyGroupPage = (): Promise<CompanyGroupPage> => {
    return getApiCall("api/companygroup", CompanyGroupPage);
};

export const getCompanyGroupListItems = (pageSize: number, page: number, filter: string, ignoreCompanyGroupIds: string[], sortColumn: string, sortOrderIsAsc: boolean): Promise<CompanyGroupListItems> => {
    return postApiCall("api/companygroup/list", CompanyGroupListItems, JSON.stringify({
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        ignoreCompanyGroupIds
    }));
};

export const getCompanyGroupEdit = (companyGroupId: string): Promise<CompanyGroupEdit> => {
    return getApiCall("api/companygroup/edit?id=" + companyGroupId, CompanyGroupEdit);
};

export const saveCompanyGroupEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/companygroup/editsave", SaveSuccess, JSON.stringify(obj));
};

export const removeCompanyGroup = (id: string): Promise<ApiSuccess> => {
    return postApiCall("api/companygroup/remove?id=" + id, ApiSuccess);
};

export const companyGroupEditRemoveCompanies = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/companygroup/editremovecompanies", ApiSuccess, JSON.stringify(obj));
};

export const companyGroupEditAddCompanies = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/companygroup/editaddcompanies", ApiSuccess, JSON.stringify(obj));
};
// #endregion CompanyGroupPage

// #region Module properties
export const getUnitNodePermissions = (): Promise<UnitNodePermissions> => {
    return getApiCall("api/companygroup/module/permissions", UnitNodePermissions);
};

export const saveUnitNodePermissions = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/companygroup/module/savepermissions", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module properties

export const getCompanyGroupForPermissionListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, groupType: number,
    ignoreCompanyGroupCodes: string[], messageTargetMode: boolean): Promise<CompanyGroupForPermissionListItems> => {
    return postApiCall("api/companygroup/listforpermissions", CompanyGroupForPermissionListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        groupType: groupType || 0,
        ignoreCompanyGroupCodes,
        messageTargetMode: messageTargetMode || false
    }));
};
